import { useDispatch, useSelector } from "react-redux";
import {
  IonCard,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from "@ionic/react";
import { selectUserRoles } from "../../store/supervisorHome/selectors/selectUserRoles";
import { bagOutline } from "ionicons/icons";
import UserAvatarRoles from "../../components/UserAvatarRoles";
import { RootState } from "../../store/rootReducer";
import { useEffect, useState } from "react";
import { setMaxUserRoleAlertListIndex } from "../../store/supervisorHome";

const MIN_ITEM_ON_LIST = 10;

export const UserRoleAlert = () => {
  const dispatch = useDispatch();

  const userRoles = useSelector(selectUserRoles);

  const maxDataList = useSelector(
    (state: RootState) => state.supervisorHome.maxUserRoleAlertListIndex
  );

  const [infiniteDisabled, setInfiniteDisabled] = useState<boolean>(false);

  useEffect(() => {
    dispatch(setMaxUserRoleAlertListIndex(MIN_ITEM_ON_LIST));
    setInfiniteDisabled(false);
  }, [userRoles]);

  const pushData = () => {
    dispatch(setMaxUserRoleAlertListIndex(maxDataList + MIN_ITEM_ON_LIST));
  };

  const loadData = (ev: any) => {
    setTimeout(() => {
      pushData();
      ev.target.complete();
      if (maxDataList > userRoles.length) {
        setInfiniteDisabled(true);
      }
    }, 500);
  };

  useIonViewWillEnter(() => {
    dispatch(setMaxUserRoleAlertListIndex(MIN_ITEM_ON_LIST));
  });

  useIonViewWillLeave(() => {
    dispatch(setMaxUserRoleAlertListIndex(MIN_ITEM_ON_LIST));
  });

  return (
    <>
      {userRoles
        .filter(({ alerts }) => alerts > 0)
        .slice(0, maxDataList)
        .map((roles) => (
          <IonCard
            routerLink={`/app/supervision/colaborador/${roles?.user?.id}`}
            key={roles?.id}
            class="ion-margin-horizontal"
          >
            <IonItem lines="none">
              <UserAvatarRoles user={roles?.user} alert={roles?.alerts} />
              <IonLabel>
                <h2 style={{ fontWeight: 500 }}>{roles?.user?.name}</h2>
                <p style={{ fontWeight: 500 }}>
                  <IonIcon icon={bagOutline}></IonIcon>
                  <span className="ion-margin-start">
                    {roles?.role?.name || "--"} en {roles?.location?.name || "--"}
                  </span>
                </p>
              </IonLabel>
            </IonItem>
          </IonCard>
        ))}
      <IonInfiniteScroll onIonInfinite={loadData} threshold="10px" disabled={infiniteDisabled}>
        <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargar más datos..." />
      </IonInfiniteScroll>
    </>
  );
};
